import styled from 'styled-components';

export const ClientLoyaltyPageContainer = styled('div')`
  width: 100%;
  margin: 0 auto;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
`;
